<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Liste des inscrits">
        <v-subheader>{{ titreAtelier }}</v-subheader>
        <v-row v-if="etudiants.length > 0">
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="etudiants"
              disable-pagination
              hide-default-footer
              item-key="id"
              class="elevation-2"
            >
              <template v-slot:[`item.dateNaissance`]="{ item }">
                {{ formatDate(item.dateNaissance) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" offset="0" offset-md="3">
            <div class="text-center">
              <router-link
                :to="{
                  name: 'gestion-ateliers',
                }"
                tag="v-btn"
              >
                <v-icon title="Retour"></v-icon>
                Retour</router-link
              >
            </div>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiEtudiantRepository from "@/repositories/ApiEtudiantRepository";
import ApiAtelierRepository from "@/repositories/ApiAtelierRepository";
import moment from "moment";

export default {
  name: "InscritsAtelier",
  components: { BaseBlock },
  props: ["idAtelier"],

  data() {
    return {
      headers: [
        {
          text: "Nom",
          align: "left",
          sortable: true,
          value: "nom",
        },
        {
          text: "Prénom",
          align: "left",
          sortable: false,
          value: "prenom",
        },
        {
          text: "Date de naissance",
          align: "center",
          sortable: true,
          value: "dateNaissance",
        },
        {
          text: "Mail",
          align: "center",
          sortable: true,
          value: "mail",
        },
        {
          text: "Téléphone",
          align: "center",
          sortable: false,
          value: "telephone",
        },
      ],
      etudiants: [],
      atelier: {},
    };
  },
  computed: {
    titreAtelier() {
      return this.atelier.id
        ? "Atelier du " +
            this.formatDateEtHeure(this.atelier.dateDebut) +
            " sur le campus  " +
            this.atelier.campus.libelle +
            " (" +
            this.atelier.lieu +
            ")"
        : "";
    },
  },
  async created() {
    if (this.idAtelier > 0) {
      await this.getAtelier(this.idAtelier);
      await this.getEtudiants();
    }
  },
  methods: {
    async getEtudiants() {
      try {
        const etudiants = await ApiEtudiantRepository.getInscritsAtelier(
          this.idAtelier
        );
        this.etudiants = etudiants;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatDateEtHeure(dateEtHeure) {
      return moment(dateEtHeure).format("DD/MM/YYYY HH:mm");
    },
    async getAtelier(id) {
      try {
        const atelier = await ApiAtelierRepository.getAtelier(id);
        this.atelier = atelier;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
  },
};
</script>
